export class Account {
    id: number;
    code: string;
    name: string;
    user: string;
    state: any;
}